import { Flex, Box, Divider } from '@chakra-ui/react'

export const SectionHeader = ({ text }) => {
  return (
    <Box>
      <Flex alignItems="center" mb={2} mx={4}>
        <Box w="14px" h="14px" bg="secondary.main" mr={2} />
        <Box fontWeight="bold" fontSize="xl">
          {text}
        </Box>
      </Flex>
      <Divider />
    </Box>
  )
}
